<template>
  <div>
    <Modal v-model="setPriceModal" width="600">
      <div slot="header" class="text-center">设置最低限价折扣</div>
      <Row :gutter="8">
        <i-col span="6">最低限价折扣</i-col>
        <i-col span="18">
          <InputNumber size="small" :max="10" :min="0" :step="0.5" v-model="discount">
          </InputNumber>
          <span class="p-l-5">折</span>
        </i-col>
      </Row>
      <div class="text-orange m-t-10">
        提示：此处填写折扣，而非百分比，85折填写8.5，不打折填写10。只对勾选项生效。
      </div>
      <div class="m-t-10">
        <div class="m-b-10">已勾选项</div>
        <div>
           <Tag color="primary" v-for="item in productList" :key="item.id">{{ item.id }} - {{item.name}}</Tag>
        </div>
      </div>
      <div slot="footer">
        <Button type="text" class="m-r-5" @click="setPriceModal = false">取消</Button>
        <Button type="primary" @click="onConfirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCompanySkuSettlementPrice } from '@/api/product/productskuedit'
export default {
  props: {
    companyId: {
      type: Number
    },
    productList: {
      type: Array,
      default: new Array(0)
    },
    onSuccessFun: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      setPriceModal: false,
      discount: 0
      // statementPrice: 0
    }
  },
  methods: {
    show () {
      this.discount = 0
      this.setPriceModal = true
    },
    onConfirm () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确认信息无误并提交？',
        onOk: () => {
          const postData = {
            companyId: this.companyId,
            discount: this.discount * 0.1,
            skuIds: JSON.stringify(this.productList.map(x => x.id))
          }
          setCompanySkuSettlementPrice(postData).then(res => {
            if (res && res.success) {
              this.setPriceModal = false
              this.discount = 0
              this.$Notice.success({ desc: '操作成功' })
              this.onSuccessFun()
            }
          })
        }
      })
    }
  }
}
</script>

<style></style>
